var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoices-history" },
    [
      _c("div", { staticClass: "is-flex space-between" }, [
        _c("div", { staticClass: "menu-docs" }, [
          _c(
            "p",
            { staticClass: "control" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "button",
                  attrs: { to: { name: "StampedList", query: _vm.query } }
                },
                [
                  _c("BIcon", {
                    staticClass: "has-text-success",
                    attrs: { icon: "bookmark", type: "is-small" }
                  }),
                  _c("span", [_vm._v("CFDI")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "control" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "button",
                  attrs: { to: { name: "SaleNoteList", query: _vm.query } }
                },
                [
                  _c("BIcon", {
                    staticClass: "has-text-primary",
                    attrs: { icon: "bookmark", type: "is-small" }
                  }),
                  _c("span", [_vm._v("Notas")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "control" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "button",
                  attrs: {
                    to: { name: "CanceledInvoiceList", query: _vm.query }
                  }
                },
                [
                  _c("BIcon", {
                    staticClass: "has-text-danger",
                    attrs: { icon: "bookmark", type: "is-small" }
                  }),
                  _c("span", [_vm._v("Canceladas")])
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", [
          _c("p", [
            _c(
              "a",
              {
                staticClass: "button is-primary",
                class: { "is-loading": _vm.isLoading },
                attrs: { disabled: _vm.isLoading },
                on: { click: _vm.downloadCfdis }
              },
              [
                _c("BIcon", { attrs: { icon: "cloud-download" } }),
                _c("span", [_vm._v(" Descarga CSV")])
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "field has-addons" },
        [
          _vm.activeType("fiscal")
            ? [
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("StampedList"),
                        attrs: {
                          to: {
                            name: "StampedList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-success",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("Facturas")])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("PreInvoiceList"),
                        attrs: {
                          to: {
                            name: "PreInvoiceList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-success",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("PreFacturas")])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("AutoInvoiceList"),
                        attrs: {
                          to: {
                            name: "AutoInvoiceList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-success",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("AutoFacturas")])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("CreditNoteList"),
                        attrs: {
                          to: {
                            name: "CreditNoteList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-success",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("Notas De Crédito")])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("PayrollsList"),
                        attrs: {
                          to: {
                            name: "PayrollsList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-success",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("Nómina")])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("RepList"),
                        attrs: {
                          to: { name: "RepList", query: { size: 20, page: 1 } }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-success",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("Pagos")])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("TradeTransfers"),
                        attrs: {
                          to: {
                            name: "TradeTransfers",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-success",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("Cartas Porte")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm.activeType("nofiscal")
            ? [
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("SaleNoteList"),
                        attrs: {
                          to: {
                            name: "SaleNoteList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-primary",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("Notas de Remisión")])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("SalaryReceiptList"),
                        attrs: {
                          to: {
                            name: "SalaryReceiptList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-primary",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("Recibos de salario")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: _vm.activeClass("CanceledInvoiceList"),
                        attrs: {
                          to: {
                            name: "CanceledInvoiceList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [
                        _c("BIcon", {
                          staticClass: "has-text-danger",
                          attrs: { icon: "bookmark", type: "is-small" }
                        }),
                        _c("span", [_vm._v("Canceladas")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
        ],
        2
      ),
      _c("RouterView")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }